export default __webpack_public_path__ + "static/media/comedora.270c0828.png";